import { Directive, Input, ElementRef, OnInit } from '@angular/core';

// Pipes
import { WPMediaSizeAsync } from '../../pipes';

export class WPFeaturedMediaOptions {
    id: number;
    size: 'full' | 'large' | 'medium' | 'thumbnail' = 'full'
}

@Directive({
  selector: '[wpFeaturedMediaBackground]'
})
export class WPFeaturedMediaBackgroundDirective implements OnInit {

    @Input() wpFeaturedMediaBackground: number | WPFeaturedMediaOptions;

    constructor(private elementRef: ElementRef, private wPMediaSizeAsync: WPMediaSizeAsync) { }

    ngOnInit() {
        if (this.wpFeaturedMediaBackground) { 
            if (typeof this.wpFeaturedMediaBackground === 'number') {
                this.getMedia(this.wpFeaturedMediaBackground, 'full');
            }
            else {
                this.getMedia(this.wpFeaturedMediaBackground.id, this.wpFeaturedMediaBackground.size);
            }
        }
    }

    private getMedia(id: number, size?: string) {
        this.wPMediaSizeAsync.transform(id, new Array<string>(size))
            .then((data) => {
                this.setBackgroundImg(data);
            })
            .catch((err) => console.error(`Media with ID ${id} not found!`, err));
    }

    private setBackgroundImg(src: string) {
        this.elementRef.nativeElement.style.backgroundImage = `url(${src})`;
    }
}
